export default __webpack_public_path__ + "static/media/buffer.fa999837.jpg";